module.exports = {
    // basic
    'include-deleted-steps': 'include deleted steps',
    'pending': 'pending',
    'template-criteria': 'template criteria',
    'undo': 'undo',
    'reason-for-rejection': 'reason for rejection',
    'dont-lock-entry': 'do not lock entry',
    'entry-rejection': 'entry rejection',


    // raw
    // template
};
